import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,{attrs:{"outlined":"","items":_vm.items,"item-text":"text","item-value":"value","label":_vm.$t('Calendar Type'),"hide-details":"auto"},model:{value:(_vm.calendar),callback:function ($$v) {_vm.calendar=$$v},expression:"calendar"}})}
var staticRenderFns = []

export { render, staticRenderFns }